import StepsComponent from '@/components/Steps/Steps.vue';

export default {
  name: 'StatusComponent',
  props: ['stepsTitles', 'subtitlesSteps', 'currentStep'],
  components: {
    StepsComponent,
  },
  data() {
    return {
    };
  },
  methods: {
  },
};
